module.exports = __webpack_public_path__ + "static/media/switchGeeks.4a03919b.png";